import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const trackFollowDealer = ({ isMC, action }) =>
    trackEvent({
        category: 'dealer favoriting',
        label: isMC ? 'message center' : 'pdp',
        action,
    });

const sqrTracking = {
    trackClicked: ({ trackingLocation }) =>
        trackEvent(
            {
                isInteractiveEvent: true,
                action: 'contact dealer clicked',
                category: 'contact dealer',
                label: `request a shipping quote - ${trackingLocation}`,
                eventName: 'contact',
                step_interaction_name: 'entry',
                interaction_type: 'contact dealer',
            },
            null
        ),
    trackSend: ({ trackingLocation }, event) =>
        trackEvent(
            {
                action: 'contact dealer send clicked',
                category: 'contact dealer',
                label: `request a shipping quote - ${trackingLocation}`,
            },
            event
        ),
    trackSuccess: ({ trackingLocation }) =>
        trackEvent(
            {
                action: 'contact dealer submitted',
                category: 'contact dealer',
                label: `request a shipping quote - ${trackingLocation}`,
                eventName: 'contact',
                step_interaction_name: 'complete',
                interaction_type: 'contact dealer',
            },
            null
        ),

    trackDealerFollowed: ({ isMC }) =>
        trackEvent({
            category: 'dealer favoriting',
            action: 'dealer added',
            label: isMC ? 'message center' : 'pdp',
            eventName: eventNameConstants.EVENT_WISHLIST,
            interaction_type: interactionTypeConstants.INTERACTION_TYPE_DEALER_FAVORITING,
            step_interaction_name: stepInteractionConstants.STEP_INTERACTION_DEALER_ADDED,
        }),
    trackDealerUnFollowed: ({ isMC }) => trackFollowDealer({ isMC, action: 'dealer removed' }),
};

export default sqrTracking;
